<script>
  import Vue from 'vue';


  export default Vue.extend({
    props  : ['name', 'checked'],
    model  : {
      prop : 'checked',
      event: 'change',
    },
    data() {
      return {
        val: this.checked,
      };
    },
    methods: {
      onChange() {
        this.$emit('change', this.val);
      },
    },
  });
</script>

<template>
  <div class="checkbox">
    <label>
      <input type="checkbox" :name="name" :checked="checked" v-model="val" @change="onChange">
      <i></i><span><slot></slot></span>
    </label>
  </div>
</template>



// WEBPACK FOOTER //
// Checkbox.vue?7013a8b2